import { Component, Input } from '@angular/core';
import { KkmBillingStatus } from './kkm-detail-header-info.types';
import { IKkm, IRetailPlace } from '../../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-kkm-detail-header-info',
  templateUrl: 'kkm-detail-header-info.component.html',
  styleUrls: ['kkm-detail-header-info.component.sass'],
})

export class KkmDetailHeaderInfoComponent {
  @Input() kkm?: IKkm;
  @Input() retailPlace?: IRetailPlace;

  readonly kkmBillingStatuses: Record<number, KkmBillingStatus> = {
    0: {
      text: 'kkm.status.REGISTRATION_SUCCESS',
      className: 'green-text',
    },
    1: {
      text: 'kkm.status.BILLING_KKM_ACTIVATED_STATUS',
      className: 'green-text',
    },
    2: {
      text: 'kkm.status.BILLING_KKM_DEACTIVATED_STATUS',
      className: 'error-text',
    },
    3: {
      text: 'kkm.billing.status.TARIFF_DISABLED',
      className: 'error-text',
    },
    4: {
      text: 'kkm.status.BILLING_KKM_BLOCKED_STATUS',
      className: 'error-text',
    },
  };

  readonly kkmRegStatuses: Record<number, string> = {
    2: 'kkm.status.REG_SENT_TO_FNS',
    3: 'kkm.status.FNS_REG_FAILED',
    4: 'kkm.status.REGISTRATION_SUCCESS',
    5: 'kkm.status.FNS_REREG_FAILED',
    6: 'kkm.status.UNREG_SENT_TO_FNS',
    7: 'kkm.status.FNS_UNREG_FAILED',
    8: 'kkm.status.UNREGISTERED',
    10: 'kkm.status.REREG_SENT_TO_FNS',
    11: 'kkm.status.AWAITING_DISCONNECTION_OFD',
    12: 'kkm.status.AWAITING_RETURN_TO_OFD',
    13: 'kkm.status.AWAITING_TRANSFER_ANOTHER_OFD',
    14: 'kkm.status.DISCONNECTED_OFD',
    15: 'kkm.status.ERROR_DISCONNECTING_OFD',
    16: 'kkm.status.ERROR_RETURNING_OFD',
    17: 'kkm.status.ERROR_SWITCHING_OFD',
  };
}
